import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/components/common/api";
import { TopicService } from "../../../../../service/forum/topic.service";
import { Topic } from "../../../../../domain/topic";
import { MessageSeverity } from "../../../../../../core/commons/message-severity";
import { Router } from "@angular/router";
import { GlobalAppService } from "../../../../../../core/commons/global-app.service";
import { MatTableDataSource, MatPaginator, MatSort } from "@angular/material";
import { QueryOptions } from "app/core/commons/query.options";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";

@Component({
  selector: "app-topic-list",
  templateUrl: "./topic-list.component.html",
  styleUrls: ["./topic-list.component.scss"],
  providers: [TopicService]
})
export class TopicListComponent implements OnInit {
  // Topics
  topics = new MatTableDataSource([]);
  queryOptions: QueryOptions;
  resultsLength: number;
  topicsData: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ["name", "mediator", "actions"];
  nameFilterControl: FormControl;

  constructor(
    private topicService: TopicService,
    private confirmationService: ConfirmationService,
    private messageService: GlobalAppService,
    private router: Router
  ) {}

  ngOnInit() {
    this.nameFilterControl = new FormControl("");
    this.queryOptions = new QueryOptions();
    this.queryOptions.size = 5;
    this.applyFilter();

    this.paginator.page.subscribe(() => {
      this.queryOptions.page = this.paginator.pageIndex;
      this.queryOptions.size = this.paginator.pageSize;
      this.applyFilter();
    });

    this.nameFilterControl.valueChanges
      .debounceTime(400)
      .subscribe(() => this.applyFilterAndReset());
  }

  /**
   * Aplicar filtros
   */
  applyFilterAndReset() {
    this.paginator.pageIndex = 0;
    this.queryOptions.size = 5;
    this.queryOptions.page = 0;
    this.applyFilter();
  }

  applyFilter() {
    this.topicService
      .pagedSearch(this.nameFilterControl.value, this.queryOptions)
      .subscribe(data => {
        this.topicsData = data;
        this.topics.data = this.topicsData.content;
        this.resultsLength = this.topicsData.totalElements;
      });
  }

  /*
    Clear inputs
  */
  isClearIconVisible(): boolean {
    if (this.nameFilterControl.value != "") return true;
    else return false;
  }

  clearInputValue() {
    this.nameFilterControl.patchValue("");
  }

  /**
   * Actions
   */
  public addTopic() {
    this.router.navigate(["home", "topic", "new"]);
  }

  public editTopic(t: Topic) {
    this.router.navigate(["home", "topic", t.id]);
  }

  public deleteTopic(topic: Topic) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el tópico?",
      icon: "fa ui-icon-delete-forever",
      accept: () => {
        this.topicService
          .delete(topic)
          .switchMap(res => this.topicService.getAll())
          .subscribe(
            c => {
              this.messageService.sendMsg(
                MessageSeverity.SUCCESS,
                "Eliminado",
                "Se ha eliminado el tópico."
              );
              this.applyFilter();
            },
            error => {
              this.messageService.sendMsg(
                MessageSeverity.ERROR,
                "Error",
                "No ha sido posible eliminar el tópico."
              );
            }
          );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/topic/topic-list/topic-list/topic-list.component.ts